// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__202UE","label":"Labeled_label__22Fj7","divider":"Labeled_divider__3zD7z"};